/**
 * 合并对象（相比Object.assign函数，会做子对象递归合并）
 * @param target 目标对象，建议{}
 * @param source 要合入的对象
 */
module.exports = function mergeObject(target, ...source) {
  let sk = null;
  for (const s of source) {
    for (const k in s) {
      sk = s[k];
      if (Object.prototype.toString.call(sk) === '[object Object]') {
        if (!(k in target)) {
          target[k] = {};
        }
        if (Object.prototype.toString.call(target[k]) === '[object Object]') {
          mergeObject(target[k], sk);
        } else {
          target[k] = sk;
        }
      } else {
        target[k] = sk;
      }
    }
  }
  return target;
};
